import { MedicaidRenewalsScreen } from "@/interactors/MedicaidRenewalsScreen";

export default function MedicaidRenewals() {
  return <MedicaidRenewalsScreen />;
}
